module.exports = __webpack_public_path__ + "img/66.d7b73066.jpg";